export default __webpack_public_path__ + "static/media/cliniter-logo-white.d002f034.png";